
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import dispositivos from "@/components/perfil/Dispositivos.vue";

export default Vue.extend({
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    ...mapState(["jwt", "esAdmin"])
  },
  methods: {
    ...mapMutations(["cerrarSesion"])
  }
});
